export const EXPECTED_TX_AMOUNT_PER_MONTH: Record<string, string> = {
  '0': '10000OrBelow',
  '10001': '10001To30000',
  '30001': '30001To50000',
  '50001': '50001To100000',
  '100001': '100001To300000',
  '300001': '300001To500000',
  '500001': '500001OrAbove',
};
